import * as React from 'react';

const ENTER_KEY_CODE = 13;
const ESCAPE_KEY_CODE = 27;

interface IProps {
  value: string,
  onChange: (s: string) => void,
  onSearch: () => void,
  onCancel: () => void,
}

export class SearchInput extends React.Component<IProps> {

  public render() {
    return (
      <input
             type="text"
             value={ this.props.value }
             onKeyDown={ this.onKeyDown }
             onChange={ this.onChange }
             placeholder="Search" />);
  }

  private onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(event.target.value);
  }

  private onKeyDown = (event: React.KeyboardEvent) => {
    switch (event.keyCode) {
      case ENTER_KEY_CODE:
        this.props.onSearch();
        break;

      case ESCAPE_KEY_CODE:
        this.props.onCancel();
        break;

      default:
        break;
    }
  }

}

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/SearchInput.tsx